module.exports = __webpack_public_path__ + "img/ky.c030bdb5.svg";